import { WagmiProvider } from 'wagmi';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { ReactNode } from 'react';
import { wagmiConfig } from 'connectors/wagmiConfig';

const queryClient = new QueryClient();

export const AppWagmiProvider = ({ children }: {children: ReactNode}) => {
  return (
	<WagmiProvider config={wagmiConfig}>
    <QueryClientProvider client={queryClient}>
			<RainbowKitProvider>
				{children}
			</RainbowKitProvider>
    </QueryClientProvider>
  </WagmiProvider>);
};
